// देवनागरी → Roman (English) reverse transliteration
import { npDigits } from './timeAgo';

const CONSONANTS = {
  'क': 'k', 'ख': 'kh', 'ग': 'g', 'घ': 'gh', 'ङ': 'n',
  'च': 'ch', 'छ': 'chh', 'ज': 'j', 'झ': 'jh', 'ञ': 'n',
  'ट': 't', 'ठ': 'th', 'ड': 'd', 'ढ': 'dh', 'ण': 'n',
  'त': 't', 'थ': 'th', 'द': 'd', 'ध': 'dh', 'न': 'n',
  'प': 'p', 'फ': 'ph', 'ब': 'b', 'भ': 'bh', 'म': 'm',
  'य': 'y', 'र': 'r', 'ल': 'l', 'व': 'v', 'श': 'sh',
  'ष': 'sh', 'स': 's', 'ह': 'h', 'ळ': 'l', 'क्ष': 'ksh', 'ज्ञ': 'gya',
};

const VOWELS = {
  'अ': 'a', 'आ': 'aa', 'इ': 'i', 'ई': 'ee', 'उ': 'u', 'ऊ': 'oo',
  'ऋ': 'ri', 'ए': 'e', 'ऐ': 'ai', 'ओ': 'o', 'औ': 'au', 'अं': 'am', 'अः': 'ah',
};

const MATRAS = {
  'ा': 'a', 'ि': 'i', 'ी': 'ee', 'ु': 'u', 'ू': 'oo',
  'े': 'e', 'ै': 'ai', 'ो': 'o', 'ौ': 'au', 'ृ': 'ri', 'ं': 'n', 'ः': 'h', 'ँ': 'n',
};

const DIGITS = { '०': '0', '१': '1', '२': '2', '३': '3', '४': '4', '५': '5', '६': '6', '७': '7', '८': '8', '९': '9' };

export function devanagariToRoman(text) {
  if (!text) return '';
  let out = '';
  const chars = Array.from(text);

  for (let i = 0; i < chars.length; i++) {
    const ch = chars[i];
    // 2-char conjuncts pahile herne
    const two = ch + (chars[i + 1] || '');
    if (CONSONANTS[two]) {
      out += CONSONANTS[two];
      i++;
      continue;
    }
    if (CONSONANTS[ch]) {
      out += CONSONANTS[ch];
      // Anusvara/matra follow garna sakcha
      continue;
    }
    if (VOWELS[ch]) { out += VOWELS[ch]; continue; }
    if (MATRAS[ch]) { out += MATRAS[ch]; continue; }
    if (DIGITS[ch]) { out += DIGITS[ch]; continue; }
    if (ch === '्') continue; // halanta — inherent vowel hataune
    out += ch;
  }

  return out;
}

export { npDigits };